/* eslint-disable max-lines-per-function */
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { getMonthNameByDateObject, getWeekdayByDate } from '@/utils';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Calendar } from './Calendar/Calendar';
import { DayProps } from 'react-day-picker';
import { useRouteParams } from './useRouteParams';
import { Button } from '@/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';

export function FallbackDialogContent() {
  const { searchParams } = useRouteParams();
  const { datum } = searchParams;

  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-col gap-6 pt-8">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-neutrals-N900">
            {t('domain.controlling.umsatzplanung.planung.dialog.title')}
          </DialogTitle>
        </DialogHeader>
        <div>
          <div className="flex gap-8 h-full">
            <div className="flex mt-[9px] pb-8 flex-col gap-8">
              <div className="flex flex-col gap-2">
                <div className="text-xs font-bold">
                  {getMonthNameByDateObject(new Date(datum))}{' '}
                  {dayjs(datum).year()}
                </div>
                <div className="text-xs text-neutrals-N700">
                  {t(
                    'domain.controlling.umsatzplanung.planung.dialog.validPlanwerteSubtitle',
                    {
                      validPlanwerteCount: 0,
                      daysInMonth: dayjs(datum).daysInMonth(),
                    },
                  )}
                </div>
              </div>
              <Calendar
                selected={new Date(datum)}
                month={new Date(datum)}
                mode="single"
                components={{
                  Day: ({ date }: DayProps) => {
                    const isDateInCurrentMonth =
                      date.getMonth() === dayjs(datum).get('month');

                    return isDateInCurrentMonth ? (
                      <Button
                        disabled
                        variant="ghost"
                        className="h-9 w-9 font-normal hover:font-semibold"
                        id={`${date}-day`}>
                        {date.getDate()}
                      </Button>
                    ) : null;
                  },
                }}
              />
            </div>
            <div className="h-full w-[1px] bg-neutrals-N300" />
            <div className="grow flex flex-col gap-2 justify-start">
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-2">
                  <Button size="icon" variant="icon" disabled>
                    <FontAwesomeIcon className="text-xl" icon={faChevronLeft} />
                  </Button>
                  <Button size="icon" variant="icon" disabled>
                    <FontAwesomeIcon
                      className="text-xl"
                      icon={faChevronRight}
                    />
                  </Button>
                </div>
                <div className="font-bold text-neutrals-N900 flex gap-1 items-baseline">
                  <span>{getWeekdayByDate(new Date(datum)).name},</span>
                  <span>{dayjs(datum).format('D.')}</span>
                  <span>{getMonthNameByDateObject(new Date(datum))}</span>
                  <span>{dayjs(datum).format('YYYY')}</span>
                </div>
                <div className="text-xs uppercase bg-neutrals-N300 py-[2px] px-1 rounded-full">
                  KW {dayjs(datum).isoWeek()}
                </div>
              </div>
              <div className="overflow-auto h-[500px] flex justify-center items-center">
                <div className="flex flex-col gap-2 items-center">
                  <FontAwesomeIcon
                    icon={faSpinnerThird}
                    spin
                    size="2x"
                    className="text-neutrals-N700"
                  />
                  <div className=" text-neutrals-N700">Wird geladen…</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="h-px bg-neutrals-N300 border-0 -mx-8"></hr>
      <div className="flex items-center justify-end py-4">
        <Button disabled>
          {t('domain.controlling.umsatzplanung.ziele.fertig')}
        </Button>
      </div>
    </>
  );
}
